import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportmenu',
  templateUrl: './reportmenu.component.html',
  styleUrls: ['./reportmenu.component.scss']
})
export class ReportmenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
